import { gaEvent } from 'src/utils'

/**
 * [TARGET]: Na exibição dos alertas de erro após o preenchimento dos campos
 *
 * [CONTEXTO]: No formulário do fluxo de pagamento do link de cobrança via cartão de crédito, caso o usuário preencha algum campo errado vamos emitir um evento.
 *
 * [REGRAS]: n/a
 *
 */

export type FormFieldErrorEventParams = {
  field: string
  error: string
}
export const formFieldErrorEvent = ({ field, error }: FormFieldErrorEventParams) => {
  const event = {
    event: 'event',
    'event-category': `pagamentos-sellout:cartao-de-credito:erro`,
    'event-action': `field:${field}`,
    'event-label': error,
  }

  gaEvent(event)
}
